export default {
  accountCreated: false
}
